import { useSelector } from "react-redux";
import Header from "../../../Shared/Header/Header";
import SideBar from "../../../Shared/Sidebar/Sidebar";
import "./Layout.scss";
import { Outlet, useLocation } from "react-router-dom";
import { LANGUAGES, LAYOUTS, NUMBER_CONSTANTS, ROUTES } from "../../../Utilities/Constants/Constants";
import Registration from "../../Authentication/Registration/Registration";
import Onboarding from "../OnboardingScreen/OnboardingScreen";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { useEffect, useState } from "react";

const Layout = () => {
   const language: any = useSelector((state: any) => {
     return state.languageReducer.language;
   });
    const location = useLocation();
    const { pathname } = location;
    const [coverData, setCoverData] = useState<any>({});

    useEffect(()=>{
      getCoverData();
    },[])
    
    const getCoverData = () => {
      axiosInstance.get(API_END_POINTS.COVER_IMAGE).then((response) => {
        setCoverData(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
      });
    }
    
  return (
    location.pathname===ROUTES.ONBOARDING_SCREEN ?
    <>
     <Header currentPage={pathname.split("/")[NUMBER_CONSTANTS.ONE]} />
     <Onboarding/>
    </>
     
    :
    <>
      <div
        className="sidebar_container_ltr"
        dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
      >
        {coverData.status === "approved" && <SideBar />}
        <div className="header_outlet_wrapper">
        <div className="background_color_wrapper">
            <div className="background_fix">
              <div className="background_color_container">
                <div className="yellow_round"></div>
                <div className="violet_round"></div>
                <div className="blue_round"></div>
              </div>
            </div>
          </div>
          <Header currentPage={pathname.split("/")[NUMBER_CONSTANTS.ONE]} />
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
